import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { globalHttpInterceptor } from '@core/interceptors/global.interceptor';

/** Ordered list of functional HTTP interceptors for the application. */
export const appHttpInterceptors = [errorInterceptor, globalHttpInterceptor];
